import { getZone, hasZone } from '../../content';
import { NPCS } from '../../content/npcs';
import { NPC_AT } from '../../content/quests';

/** Display names for zones without building their layouts. */
const ZONE_NAMES: Record<string, string> = {
  emberwild: 'Emberwild Vale',
  havenreach: 'Havenreach',
  sunscar: 'Sunscar Expanse',
  frosthollow: 'Frosthollow',
  crypt: 'Hollowroot Crypt',
  tomb: 'Sandsworn Tomb',
  keep: 'Frostfang Keep',
  sea: 'The Gleaming Sea',
  haven: 'Haven Isle',
  glimmer: 'Glimmer Isle',
  rift_1: 'Rift Delve',
  colossus_cinderhide: 'Colossus Hunt',
  deepvault_1: 'The Sunken Reliquary',
  siege_2: 'Warlord Siege',
};

export function zoneName(id: string): string {
  const known = ZONE_NAMES[id];
  if (known) return known;
  try {
    return hasZone(id) ? getZone(id).name : id;
  } catch {
    return id;
  }
}

export const npcName = (id: string): string => NPCS[id]?.name ?? id;
export const npcRole = (id: string): string => NPCS[id]?.role ?? '';

/** Which zone an NPC stands in (overworld layouts; null when unknown). */
export function npcZone(
  id: string,
  zones: readonly string[] = ['emberwild', 'havenreach', 'sunscar', 'frosthollow', 'haven'],
): string | null {
  const known = NPC_AT[id];
  if (known) return known.zone;
  for (const z of zones) {
    try {
      if (hasZone(z) && getZone(z).npcs.some((n) => n.npc === id)) return z;
    } catch {
      /* a broken layout should not break the journal */
    }
  }
  return null;
}
